"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AncientDecayEffectHandler = exports.AncientDecayEffectArgs = void 0;
const Duration_1 = require("../../Duration");
const core_1 = require("../../event-handlers/core");
const EventType_1 = require("../../events/EventType");
const Schedule_1 = require("../../Schedule");
const Registries_1 = require("../../state/Registries");
const Target_1 = require("../../Target");
const EffectType_1 = require("../EffectType");
const AncientDecayTick_1 = require("./AncientDecayTick");
class AncientDecayEffectArgs {
    constructor() {
        this.__type = EffectType_1.EffectType.AncientDecay;
        this.__typeName = "AncientDecay";
        this.name = "Ancient Decay";
        this.harmful = true;
    }
}
exports.AncientDecayEffectArgs = AncientDecayEffectArgs;
let AncientDecayEffectHandler = class AncientDecayEffectHandler {
    apply(sequence, container, state) {
        const amount = container.getPercentOfBaseHealth(state.targetId, 5);
        state.meta.ehId = container.registerEventHandler(state.targetId, EventType_1.EventType.TurnStarted, Schedule_1.Schedule.LimitedEmissions(2), new core_1.ApplyEffectEventHandlerArgs(state.creatorId, Target_1.Target.Any([state.targetId]), Duration_1.Duration.Permanent, new AncientDecayTick_1.AncientDecayTickEffectArgs(amount), true));
        state.meta.appliedOnTurn = container.getActor(state.targetId).turnCount;
    }
    remove(sequence, container, state) {
        sequence = sequence.pushSequence("parallel");
        container.cancelEventHandler(state.meta.ehId);
        const turnCount = container.getActor(state.targetId).turnCount;
        const count = Math.min(2, turnCount - state.meta.appliedOnTurn);
        container.getEffectsOfType(state.targetId, EffectType_1.EffectType.AncientDecayTick)
            .slice(0, count)
            .forEach(tick => container.cancelEffect(sequence, tick));
    }
};
AncientDecayEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.AncientDecay)
], AncientDecayEffectHandler);
exports.AncientDecayEffectHandler = AncientDecayEffectHandler;
